import React, { useState, useEffect } from 'react';
import PDFViewer from '../../dashboard/components/PDFViewer';
import './MediaModal.css';

export default function MediaModal({ medias = [], initialIndex = 0, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [isExpanded, setIsExpanded] = useState(false);
  const [pdfBlob, setPdfBlob] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const apiBase = process.env.REACT_APP_URL_BASE || '';
  const apiOrigin = apiBase.replace(/\/api\/?$/i, '').replace(/\/$/, '');

  const currentMedia = medias[currentIndex];
  const isPdf = currentMedia?.toLowerCase().endsWith('.pdf');

  // Monitorar mudanças de tamanho de tela
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Carregar PDF como blob quando necessário
  useEffect(() => {
    if (!isPdf) {
      setPdfBlob(null);
      return;
    }

    const loadPdf = async () => {
      setPdfLoading(true);
      try {
        const response = await fetch(`${apiOrigin}/uploads/${currentMedia}`);
        const blob = await response.blob();
        setPdfBlob(blob);
      } catch (err) {
        console.error('Erro ao carregar PDF:', err);
      } finally {
        setPdfLoading(false);
      }
    };

    loadPdf();
  }, [currentMedia, isPdf, apiOrigin]);

  const handlePrevious = () => {
    setCurrentIndex(prev => (prev === 0 ? medias.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex(prev => (prev === medias.length - 1 ? 0 : prev + 1));
  };

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div
      className={`media-modal-overlay ${isExpanded ? 'expanded' : ''}`}
      onClick={isExpanded ? () => {} : onClose}
    >
      <div
        className={`media-modal ${isExpanded ? 'expanded-modal' : ''}`}
        onClick={e => e.stopPropagation()}
      >
        {/* Botão de fechar normal (modal) */}
        {!isExpanded && (
          <button className="media-close-btn" onClick={onClose}>
            ✕
          </button>
        )}

        {/* Botão de expandir - Apenas para imagens */}
        {!isPdf && !isExpanded && (
          <button
            className="media-expand-btn"
            onClick={toggleExpanded}
            title="Expandir para tela cheia"
          >
            ⛶
          </button>
        )}

        {/* Botão de fechar (modo expandido) */}
        {isExpanded && (
          <button
            className="expand-close-btn"
            onClick={toggleExpanded}
            title="Sair do modo expandido"
          >
            ✕
          </button>
        )}

        {/* Conteúdo de mídia */}
        <div className="media-container">
          {isPdf ? (
            <>
              {/* Desktop: iframe nativo do navegador */}
              {!isMobile && (
                <iframe
                  src={`${apiOrigin}/uploads/${currentMedia}`}
                  className="pdf-viewer-desktop"
                  title="PDF Viewer"
                />
              )}

              {/* Mobile: PDFViewer customizado */}
              {isMobile && pdfBlob && !pdfLoading && (
                <div className="pdf-viewer-mobile-wrapper">
                  <PDFViewer blob={pdfBlob} fileName={currentMedia} />
                </div>
              )}

              {/* Loading state mobile */}
              {isMobile && pdfLoading && (
                <div className="pdf-loading">
                  <div className="spinner"></div>
                  <p>Carregando PDF...</p>
                </div>
              )}
            </>
          ) : (
            <img
              id="media-display"
              src={`${apiOrigin}/uploads/${currentMedia}`}
              alt="Visualização"
              className="media-image"
            />
          )}
        </div>

        {/* Navegação */}
        {medias.length > 1 && !isExpanded && (
          <div className="media-navigation">
            <button className="nav-btn prev-btn" onClick={handlePrevious}>
              ❮ Anterior
            </button>
            <span className="media-counter">
              {currentIndex + 1} de {medias.length}
            </span>
            <button className="nav-btn next-btn" onClick={handleNext}>
              Próximo ❯
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
